var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6689 5.5C11.6689 9.5 6.66895 13 6.66895 13C6.66895 13 1.66895 9.5 1.66895 5.5C1.66895 4.17392 2.25539 2.90215 3.28059 1.96447C4.30579 1.02678 5.68992 0.5 7.16895 0.5C8.14798 0.5 9.03199 1.02678 9.55731 1.96447C10.0825 2.90215 11.6689 4.17392 11.6689 5.5Z",
    fill: "#008C23",
    stroke: "#008C23",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.66895,
    cy: 5.5,
    r: 1.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopsIcon);
export default __webpack_public_path__ + "static/media/stops_icon.83f873c38107430cdfc9373a2b26c9c7.svg";
export { ForwardRef as ReactComponent };